class ListCompanyController {
  constructor(entityService, loadingService) {
    "ngInject";

    this._entityService = entityService;
    this.loadingService = loadingService;

    this.companies = [];

    this.listCompanies();
  }

  listCompanies(entityType) {
    let listCompanyCtrl = this;

    listCompanyCtrl.loadingService.showLoading('companyList', 'Loading Entities ...');

    this._entityService.listEntities(1)
      .then(response => {
        listCompanyCtrl.companies  = response.data.data;
      })
      .finally(() => {
        listCompanyCtrl.loadingService.hideLoading('companyList')
      });
  }
}

export default ListCompanyController;



// WEBPACK FOOTER //
// ./client/app/components/admin/entity/list/listCompany/listCompany.controller.js